// UserTable.js
import React from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Box,
  useColorModeValue,
  Avatar,
} from "@chakra-ui/react";
import { CiUser } from "react-icons/ci";

const OrgUserTable = ({ users }) => {
  console.log(users)
  return (
    <Box overflowX="auto" mt={5}>
      <Table>
        <Thead>
          <Tr>
            <Th><CiUser fontSize={20} /></Th>
            <Th>Name</Th>
            <Th>Email</Th>
            <Th>Organization</Th>
            <Th>CreatedAt</Th>
          </Tr>
        </Thead>
        <Tbody>
          {users.map((user,i) => (
            <Tr key={user._id}>
                <Td><Avatar bg="ActiveCaption" name={user.name.charAt(0)} size="sm" mr={2} />
                </Td>
              <Td>{user.name}</Td>
              <Td>{user.email}</Td>
              <Td>{user?.orgName}</Td>
              <Td>{user.createdAt}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default OrgUserTable;